import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { removeError } from "./../../redux/actions/authActions";

const AlertDialog = props => {
  const resetError = () => {
    props.actions.removeError();
  };

  const handleActions = action => {
    resetError();
    action();
  };

  const { errorTitle, errorDesc, actions } = props.auth;
  return (
    <div>
      <Dialog
        open={errorTitle ? true : false}
        onClose={removeError}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{errorTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorDesc}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {actions &&
            actions.map(action => (
              <Button
                onClick={() => handleActions(action.action)}
                color="primary"
              >
                {action.name}
              </Button>
            ))}
        </DialogActions>
      </Dialog>
    </div>
  );
};
const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ removeError }, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertDialog);



// WEBPACK FOOTER //
// ./src/components/common/AlertDialog.js